<template>
  <div style="margin-top: -13px">
    <v-container fluid>
      <v-card elevation="0">
        <v-form novalidate ref="forms" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-card
                class="mx-5 mt-5 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  style="text-transform: uppercase"
                  disabled
                  v-model="getOwnerFullName"
                  label="Utilizador"
                  class="purple-input"
                />
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="mt-n10">
              <v-card
                class="mx-5 mt-5 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  style="text-transform: uppercase"
                  disabled
                  v-model="getNIF"
                  label="NIF EMPRESA"
                  class="purple-input"
                />
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-card
                class="mx-5 mt-n10 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  style="text-transform: uppercase"
                  disabled
                  label="Empresa"
                  v-model="getUserNameEntity"
                  class="purple-input"
                />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xs="12" sm="6" md="12" lg="12" class="mt-n10">
              <v-card
                class="mx-5 mt-0 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  v-model="Address"
                  :rules="addressRules"
                  :label="getEntityAddress"
                  class="purple-input"
                />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" class="mt-n10">
              <v-card
                class="mx-5 mt-0 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  disabled
                  :label="getEntityCellphone"
                  class="purple-input"
                />
              </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" class="mt-n10">
              <v-card
                class="mx-5 mt-0 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  v-model="telephone"
                  :rules="telephoneRules"
                  :label="
                    getEntityTelephone
                      ? getEntityTelephone
                      : 'Digite o número de um telefone alternativo'
                  "
                  class="purple-input"
                />
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" class="mt-n10 mx-6">
              <v-btn
                class="mx-0 font-weight-light"
                color="success"
                text
                @click="updateProfileEntity"
              >
                Actualizar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>

    <div style="margin-top: -13px">
      <v-container fluid>
        <v-card elevation="0">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-card
                  class="mx-5 mt-5 transparent"
                  elevation="0"
                  min-width="250"
                >
                  <v-file-input
                    id="file"
                    type="file"
                    show-size
                    counter
                    multiple
                    label="Carregar fotografia de perfil"
                    accept="image/png, image/jpeg"
                    @change="croppie"
                  >
                  </v-file-input>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="1">
                <v-card
                  class="mx-5 mt-5 transparent"
                  elevation="0"
                  min-width="250"
                >
                  <v-avatar size="70" v-show="showAvatar">
                    <img :src="cropped" />
                  </v-avatar>
                </v-card>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                <v-card
                  class="mx-5 mt-5 transparent"
                  elevation="0"
                  min-width="250"
                >
                  <div>
                    <vue-croppie
                      class="text-left"
                      v-show="showCrop"
                      ref="croppieRef"
                      :enableOrientation="true"
                      @update="update"
                      :boundary="{
                        width: 300,
                        height: 200
                      }"
                      :viewport="{
                        width: 250,
                        height: 150,
                        type: 'square'
                      }"
                    >
                    </vue-croppie>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-card
                  class="mx-5 mt-5 transparent"
                  elevation="0"
                  min-width="250"
                >
                  <div>
                    <v-btn
                      @click="crop"
                      text
                      color="success"
                      v-show="showCrop"
                      class="mx-0 font-weight-light"
                    >
                      Actualizar
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>
import eventBus from "../../../../main";
import { mapHelperEnterprise } from "@/store/helperEnterprise";
export default {
  name: "ProfileCompEnterprise",
  data: () => ({
    croppieImage: "",
    telephone: "",
    Address: "",
    cropped: null,
    showCrop: false,
    showAvatar: false,
    valid: false,
    telephoneRules: [
      v => !!v || "Telefone é requerido",
      v => /[0-9]\d{7}$/.test(v) || "Telefone inválido"
    ],
    addressRules: [
      v => !!v || "Endereço é requerido",
      v => (v && v.length >= 4) || "Endereço inálido"
    ],
  }),
  watch: {},
  computed: {
    ...mapHelperEnterprise
  },
  methods: {
    updateProfileEntity() {
      if (this.$refs.forms.validate()) {
        let payload = {
          address: this.Address,
          telephone: this.telephone
        };
        this.$store.dispatch("entityProfileUpdate", payload);
      }
    },
    getSize() {
      let el = document.getElementById("file");
      if (el.value) {
        let eSize = el.files[0].size / 1000;
        if (eSize >= 1000) {
          alert(parseFloat(eSize * 0.001).toFixed(2) + " MB");
          return false;
        } else {
          //alert(eSize + " KB");
          return true;
        }
      }
    },
    openDeleteAccount() {
      eventBus.$emit("openDeleteAccount", true);
    },
    croppie() {
      // var files = e.target.files || e.dataTransfer.files;
      var files = document.getElementById("file").files;
      if (!files.length) return;

      var reader = new FileReader();
      this.showCrop = true;
      reader.onload = e => {
        this.$refs.croppieRef.bind({
          url: e.target.result
        });
      };

      reader.readAsDataURL(files[0]);
    },
    crop() {
      // Options can be updated.
      // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
      if (this.getSize()) {
        let options = {
          type: "base64",
          size: { width: 150, height: 100 },
          format: "jpeg"
        };

        this.$refs.croppieRef.result(options, output => {
          this.showAvatar = true;
          this.cropped = this.croppieImage = output;
          //console.log(this.croppieImage);
          let formData = new FormData();
          // let payload = {
          //   avatar: this.cropped
          //   // avatar: this.cropped.replace("data:", "").replace(/^.+,/, "")
          // };
          formData.append("avatar", this.cropped);
          //alert(this.createNewImage(this.cropped));
          this.$store.dispatch("entityAvatars", formData);
        });
      }
    },

    // EVENT USAGE
    update() {
      let options = {
        type: "base64",
        size: { width: 150, height: 100 },
        format: "jpeg"
      };
      this.$refs.croppieRef.result(options, output => {
        this.showAvatar = true;
        this.cropped = this.croppieImage = output;
        //console.log(this.croppieImage);
        // console.log(buffer.jpg);
      });
    }
  }
};
</script>

<style scoped>
.img-container {
  width: 300px;
  height: 300px;
  border: 1px solid red;
  /*float: left;*/
}
.img-preview {
  max-width: 100%;
  width: 150px;
  height: 150px;
  float: left;
  margin-left: 10px;
}
</style>
